module.exports = __webpack_public_path__ + "static/media/icon-email.a6455243.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-email.svg
// module id = 929
// module chunks = 0